import React from 'react'

export interface SvgInlineProps {
    component: React.FC<React.SVGProps<SVGSVGElement>>
    size?: number | string
    className?: string
    style?: React.CSSProperties
}

/**
 * Універсальний компонент для вставки SVG
 * Приймає імпортований SVG компонент (*.svg?react)
 * 
 * @example
 * import MyIcon from './icons/my-icon.svg?react'
 * <SvgInline component={MyIcon} size={24} />
 */
export const SvgInline: React.FC<SvgInlineProps> = ({ 
    component: SvgComponent, 
    size = 20, 
    className, 
    style
}) => {
    const sizeStyle = typeof size === 'number' ? `${size}px` : size
    
    return (
        <SvgComponent 
            className={className}
            width={sizeStyle}
            height={sizeStyle}
            style={style}
        />
    )
}
